import StarRating from "tds/starRating";

export { StarRating };

customElements.define("tds-star-rating", StarRating.CustomElementConstructor);
